import React from "react";
import logoGoogle from '../../assetImages/undraw_mobile_login_ikmv.svg';
import logoConnect from '../../assetImages/undraw_progressive_app_m9ms.svg';
import logoPostPhoto from '../../assetImages/undraw_upload_image_iwej.svg';
import logoSync from '../../assetImages/undraw_file_sync_ot38.svg';
import Grid from "@material-ui/core/Grid";
import {MdNavigateNext} from 'react-icons/md';
import {MdNavigateBefore} from 'react-icons/md';
import Avatar from 'react-avatar';
import {Picture} from 'react-responsive-picture';

const screens = [{
    image: logoGoogle,
    header: 'Login',
    description: 'Start the mobile app and login with your existing Google account'
},
    {
        image: logoConnect,
        header: 'Connect',
        description: 'Start the desktop app and scan the shown QR code to pair both devices'
    },
    {
        image: logoPostPhoto,
        header: 'Record',
        description: 'Take photos you want to quickly use on your workstation'
    },
    {
        image: logoSync,
        header: 'Copy & Paste',
        description: 'Use the app to easily copy images to your workstation\'s clipboard'
    }];

class GetStartedWidget extends React.Component {

    constructor(props) {
        super(props);
        this.handleNextButton = this.handleNextButton.bind(this);
        this.handlePrevButton = this.handlePrevButton.bind(this);
        this.state = {
            currentStep: 0
        };
    }

    componentDidUpdate(prevProps) {
        window.scrollTo(0, 0)
    }

    handleNextButton() {
        let nextStep = this.state.currentStep + 1;
        if (nextStep == screens.length) {
            nextStep = 0;
        }
        this.setState({
            currentStep: nextStep
        });
    }

    handlePrevButton() {
        let nextStep = this.state.currentStep - 1;
        if (nextStep == -1) {
            nextStep = screens.length - 1;
        }
        this.setState({
            currentStep: nextStep
        });
    }

    render() {
        const {appStyle} = this.props;

        return (
            <div className={appStyle.onboardingScreen}>


                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <div
                            className={appStyle.onboardingStepCounter}>{(this.state.currentStep + 1).toString() + ""}</div>
                    </Grid>
                    <Grid item xs={2}>
                        <button className={appStyle.onboardingBigButton} onClick={this.handlePrevButton}>
                            <MdNavigateBefore
                                className={appStyle.onboardingButtonIcon} color={'#6159E5'}/></button>
                    </Grid>
                    <Grid item xs={2}>
                        <button className={appStyle.onboardingBigButton} onClick={this.handleNextButton}>
                            <MdNavigateNext
                                className={appStyle.onboardingButtonIcon} color={'#6159E5'}/></button>
                    </Grid>
                </Grid>

                <div>
                    <h1>{screens[this.state.currentStep].header}</h1>
                    <p>{screens[this.state.currentStep].description}</p>
                </div>

                <div className={appStyle.imgbox}>
                    <img className={appStyle.centerFit} src={screens[this.state.currentStep].image}/>
                </div>
            </div>
        );
    }
}

export default GetStartedWidget;